(function(global) {
    const storage = global.localStorage || global.sessionStorage;

    class OverlayElement extends HTMLDivElement {
        _closeable = true;

        connectedCallback() {
            this.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
            this.style.width = this.style.height = '100%';

            this.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                if (this._closeable) {
                    // noinspection JSUnresolvedFunction
                    this.parentElement.hide();
                }
            });
        }

        set closeable(value: boolean): void {
            this._closeable = value;
        }

        get closeable(): boolean {
            return this._closeable;
        }
    }

    class ContainerElement extends HTMLDivElement {
        skippable: string;
        defaultButton: HTMLButtonElement;

        constructor(...args) {
            super(...args);
            this.headerElement = document.createElement('h2');
            this.contentElement = document.createElement('div');
            this.skippableElement = document.createElement('div');
            this.buttonsContainerElement = document.createElement('div');

            Object.defineProperty(this.skippableElement, 'checked', {
                get: () => !!(this.skippableElement.querySelector('input[type="checkbox"]') || {}).checked
            });
        }

        connectedCallback() {
            this.style.position = 'absolute';
            this.style.left = this.style.top = '50%';
            // noinspection JSDeprecatedSymbols
            this.style.transform = this.style.webkitTransform = this.style.msTransform = 'translate(-50%, -50%)';
            this.style.minWidth = '300px';
            this.style.minHeight = '140px';
            this.style.backgroundColor = 'white';
            this.style.boxShadow = '0 0 5px rgba(0,0,0,0.3),0 0 20px rgba(0,0,0,0.3)';
            this.style.padding = '10px 40px';
            this.style.maxHeight = '70vh';
            this.style.maxWidth = '70vw';
            this.style.overflow = 'auto';

            this.headerElement.style.textAlign = 'center';
            this.headerElement.style.fontWeight = 'bold';
            this.headerElement.style.textShadow = '2px 2px 3px rgba(0, 0, 0, 0.2)';
            this.headerElement.style.fontSize = '32px';
            this.headerElement.style.marginBottom = '25px';

            this.buttonsContainerElement.style.display = 'flex';
            this.buttonsContainerElement.style.justifyContent = 'center';

            this.skippableElement.classList.add('checkbox');
            this.skippableElement.style.textAlign = 'center';
            const label = this.skippableElement.appendChild(document.createElement('label'));
            const checkbox = label.appendChild(document.createElement('input'));
            checkbox.setAttribute('type', 'checkbox');
            const i = label.appendChild(document.createElement('i'));
            i.classList.add('input-helper');
            label.appendChild(document.createTextNode('Nie wyświetlaj więcej tego okna.'));

            this.appendChild(this.headerElement);
            this.appendChild(this.contentElement);
            this.appendChild(this.skippableElement);
            this.appendChild(this.buttonsContainerElement);

            this.contentElement.style.minHeight = '40px';

            if (!this.skippable) {
                this.skippableElement.style.display = 'none';
            }
        }

        set content(value: string | HTMLElement) {
            while (this.contentElement.firstChild) {
                this.contentElement.removeChild(this.contentElement.firstChild);
            }

            if (typeof value === 'string') {
                this.contentElement.innerText = value;
                this.contentElement.style.setProperty('text-align', 'center');
            } else if (typeof value === 'object' && value instanceof HTMLElement) {
                this.contentElement.appendChild(value);
                this.contentElement.style.removeProperty('text-align');
            } else {
                console.error('Treść popupa może być jedynie stringiem lub obiektem typu HTMLElement.');
            }
        }

        set skippableName(name: string): void {
            this.skippable = name;
            this.skippableElement.style.display = name ? 'block' : 'none';
        }

        set header(value: string): void {
            this.headerElement.innerText = value;

            if (value && value.length) {
                this.headerElement.style.minHeight = '60px';
                this.headerElement.style.paddingBottom = '25px';
                this.style.minHeight = '200px';
            } else {
                this.headerElement.style.minHeight = this.headerElement.style.paddingBottom = '0';
                this.style.minHeight = '140px';
            }
        }

        addButton(text: string, action: () => void): HTMLButtonElement {
            const button = document.createElement('button');
            button.classList.add('btn', 'btn-primary');
            button.style.marginLeft = button.style.marginRight = '5px';
            button.innerText = text;

            if (action) {
                button.addEventListener('click', e => {
                    if (this.skippable && button === this.defaultButton) {
                        if (this.skippableElement.checked) {
                            storage.setItem(this.skippable, 'yes');
                        }
                    }

                    action(e);
                });
            }

            this.buttonsContainerElement.appendChild(button);

            return button;
        }

        addDefaultButton(text: string, action: () => void): HTMLButtonElement {
            return this.defaultButton = this.addButton(text, action);
        }
    }

    class PopupElement extends HTMLDivElement {
        transition: number = 400;
        name: string;
        defaultButton: HTMLButtonElement;
        cancelButton: HTMLButtonElement;
        hidden: boolean = true;

        constructor(...args) {
            super(...args);

            this.overlay = new OverlayElement();
            this.container = new ContainerElement();

            this.escCallback = (e: KeyboardEvent) => {
                // noinspection JSDeprecatedSymbols
                if (("key" in e && (e.key === 'Escape' || e.key === 'Esc')) || e.keyCode === 27 || e.which === 27) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (this.cancelButton) {
                        this.cancelButton.click();
                    } else if (this.overlay.closeable) {
                        this.hide();
                    }
                }
            }
        }

        connectedCallback(): void {
            this.style.width = '100vw';
            this.style.height = '100vh';
            this.style.position = 'fixed';
            this.style.left = this.style.top = '0px';
            this.style.zIndex = '9999';
            this.style.opacity = '0';
            this.style.transition = `${this.transition}ms`;

            setTimeout(() => this.style.opacity = '1');

            this.appendChild(this.overlay);
            this.appendChild(this.container);

            document.addEventListener('keydown', this.escCallback);
        }

        disconnectedCallback(): void {
            document.removeEventListener('keydown', this.escCallback);
        }

        set header(value: string): void {
            this.container.header = value;
        }

        set content(value: string | HTMLElement): void {
            this.container.content = value;
        }

        set closeable(value: boolean): void {
            this.overlay.closeable = value;
        }

        set skippable(skippable: boolean): void {
            if (!skippable) {
                this.container.skippableName = delete this.name;
                return;
            }

            const e = new Error();
            const stack = e.stack.split(/\r?\n/);
            const line = stack[1].substr(stack[1].lastIndexOf(':') + 1);
            this.container.skippableName = this.name = `Popup_${line}`;
        }

        get skippable(): boolean {
            return !!this.name;
        }

        addButton(text: string, action: () => void = () => {}): HTMLButtonElement {
            return this.container.addButton(text, action);
        }

        addDefaultButton(text: string, action: () => void = () => {}): HTMLButtonElement {
            if (this.defaultButton && console.warn) {
                console.warn('Default button already set.');
            }

            return this.defaultButton = this.container.addDefaultButton(text, action);
        }

        addCancelButton(text: string, action: () => void = () => {}): HTMLButtonElement {
            if (this.cancelButton && console.warn) {
                console.warn('Cancel button already set.');
            }

            return this.cancelButton = this.addButton(text, action);
        }

        show(): boolean {
            if (this.parentElement || !this.hidden) {
                return false;
            }

            if (this.skippable) {
                if (!this.defaultButton && console.warn) {
                    console.warn('Skippable popup must have the default button set.');
                }

                if (storage.getItem(this.name) === 'yes') {
                    if (this.defaultButton) {
                        this.defaultButton.click();
                    }

                    return true;
                }
            }

            if (document.activeElement) {
                // noinspection JSUnresolvedFunction
                document.activeElement.blur();
            }

            document.body.appendChild(this);
            this.hidden = false;

            return true;
        }

        hide(): boolean {
            if (!this.parentElement || this.hidden) {
                return false;
            }

            this.style.opacity = '0';
            this.hidden = true;
            setTimeout(() => this.remove(), this.transition);

            return true;
        }
    }

    customElements.define('ce-popup', PopupElement, {extends: 'div'});
    customElements.define('ce-popup-overlay', OverlayElement, {extends: 'div'});
    customElements.define('ce-popup-container', ContainerElement, {extends: 'div'});

    global.HTMLElements = global.HTMLElements || {};
    global.HTMLElements.PopupElement = PopupElement;
})(window);
